const getters = {
  applications: state => state.application.loadedApplications,
  currentUser: state => state.user.currentUser,
  application: state => state.application.loadedApplication,
  documentTypes: state => state.application.documentTypes,
  documents: state => state.application.loadedApplication.documents,
  loading: state => state.context.loading,
  redirectTo: state => state.context.redirectTo,
  snackbar: state => state.context.snackbar,
  subpoenaedApplication: state => state.application.subpoenaedApplication,
  userSignUp: state => state.user.userSignUpData,
};
export default getters;
